import ErrorApi from "./../utils/ErrorApi"
import JsonFetch from "./../utils/JsonFetch"

if (serverContextPath === null) {
    console.error("Global variable serverContextPath is not defined (is null)!");
}

export default class EsbApi {
    static baseUrl =                    `${serverContextPath}/api`;
    static esb =                        EsbApi.baseUrl + '/esb';

    static subjekty =                   EsbApi.esb + '/subjekty';
    static pravniFormy =                EsbApi.esb + '/pravniFormy';
    static subjektyVyhledat =           EsbApi.esb + '/subjekty/vyhledat';

    static getSubjekty(fulltext, kodOrganizace, kodRole, max) {
        const uri = `${EsbApi.subjekty}?fulltext=${encodeURIComponent(fulltext)}&kodOrganizace=${encodeURIComponent(kodOrganizace)}&kodRole=${encodeURIComponent(kodRole)}&max=${max}`;
        return ErrorApi.responseResolver(JsonFetch.get(uri));
    }

    static getSubjekt(id) {
        const uri = `${EsbApi.subjekty}/${id}`;
        return ErrorApi.responseResolver(JsonFetch.get(uri));
    }

    static updateSubjekt(id, data) {
        const uri = `${EsbApi.subjekty}/${id}`;
        return ErrorApi.responseResolver(JsonFetch.put(uri, null, data));
    }

    static getPravniFormy() {
        const uri = EsbApi.pravniFormy;
        return ErrorApi.responseResolver(JsonFetch.get(uri));
    }

    static zaevidujSubjekt(subjekt, kodRole, kodOrganizace) {
        const uri = EsbApi.subjekty;
        const params = {
            kodRole,
            kodOrganizace,
        }
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, subjekt));
    }

    static vyhledejSubjekt(subjekt, kodRole, kodOrganizace) {
        const uri = EsbApi.subjektyVyhledat;
        const params = {
            kodRole,
            kodOrganizace,
        }
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, subjekt));
    }
}
